import Base from "../base/Base";
import Article from "../article/Article";
import Topic from "./Topic";
import Vue from "vue";
import Scenery from "../lover/Scenery";
import {sceneryMap, sceneryList} from "../../store/Sceneries";
import {startWith} from "../../filter/str";
import Person from "../person/Person";

let Type = {

	ARTICLE: "ARTICLE",
	PERSON: "PERSON",
	URL: "URL",
	TOPIC: "TOPIC",
	SCENERY: "SCENERY",
	//仅仅作为父节点。
	PARENT: "PARENT"
};

let TypeMap = {

	ARTICLE: {
		name: "链接文章",
		value: "ARTICLE",
		style: "success"
	},
	PERSON: {
		name: "链接人物",
		value: "PERSON",
		style: "success"
	},
	URL: {
		name: "自定义链接",
		value: "URL",
		style: "info"
	},
	TOPIC: {
		name: "专题",
		value: "TOPIC",
		style: "info"
	},
	SCENERY: {
		name: "定制页面",
		value: "SCENERY",
		style: "info"
	},

	PARENT: {
		name: "父级菜单",
		value: "PARENT",
		style: "primary"
	}
};

let TypeList = [];
for (let key in TypeMap) {
	TypeList.push(TypeMap[key]);
}


export default function TopicMenu() {

	//extend Base's TopicMenus.
	Base.call(this, arguments);

	this.name = null;
	//level从0开始。
	this.level = 0;
	this.article = new Article();
	this.person = new Person();
	this.topic = new Topic();
	this.scenery = new Scenery();
	this.menus = [];
	this.type = Type.ARTICLE;
	//路径名称
	this.location = null;

	//父节点
	this.parent = null;
	//所在的topic.
	this.parentTopic = new Topic();
	//供首页移动端菜单栏使用。
	this.active = false;

}


//extend SurveyComponent's Methods.
TopicMenu.prototype = new Base();
TopicMenu.prototype.constructor = TopicMenu;
TopicMenu.prototype.TAG = "topicMenu";
TopicMenu.prototype.TAGS = "topicMenus";

TopicMenu.prototype.Type = Type;
TopicMenu.prototype.TypeMap = TypeMap;
TopicMenu.prototype.TypeList = TypeList;

TopicMenu.prototype.getFilters = function () {
	return [];
};

//是否是一个父节点。
TopicMenu.prototype.isParent = function () {
	return this.menus && this.menus.length;
}

TopicMenu.prototype.render = function (obj) {

	Base.prototype.render.call(this, obj);

	this.renderList("menus", TopicMenu);

	//这里我们并不关心文章是什么，只关心id.
	if (obj) {
		if (obj.articleId) {
			this.article.id = obj.articleId;
		}
		if (obj.personId) {
			this.person.id = obj.personId;
		}

		if (obj.topicId) {
			this.topic.id = obj.topicId;

			//当类型为 TOPIC的时候，topic的location就是 这里的 location
			if (obj.type === Type.TOPIC) {
				this.topic.location = obj.location;
			}
		}
		if (obj.sceneryId) {
			this.scenery.render(sceneryMap[obj.sceneryId]);
		}

	}


}
TopicMenu.prototype.validate = function () {

	if (!this.name) {
		this.errorMessage = "请输入菜单名称";
		return false;
	}
	if (!Type[this.type]) {
		this.errorMessage = "请选择菜单类型";
		return false;
	}

	if (this.type === Type.ARTICLE || this.type === Type.PERSON || this.type === Type.SCENERY || this.type === Type.PARENT) {
		if (!this.location) {
			this.errorMessage = "访问地址必填！";
			return false;
		}
	}


	if (this.type === Type.ARTICLE) {
		if (!this.article.id) {
			this.errorMessage = "请选择关联文章";
			return false;
		}
	} else if (this.type === Type.PERSON) {
		if (!this.person.id) {
			this.errorMessage = "请选择关联人物";
			return false;
		}
	} else if (this.type === Type.URL) {

		if (!this.url) {
			this.errorMessage = "请填写菜单链接";
			return false;
		}
	} else if (this.type === Type.TOPIC) {
		if (!this.topic.id) {
			this.errorMessage = "请选择关联的专题";
			return false;
		}
	} else if (this.type === Type.SCENERY) {
		if (!this.scenery.id) {
			this.errorMessage = "请选择定制页面";
			return false;
		}
	}

	return true;
}

TopicMenu.prototype.getForm = function () {

	let info = [];
	for (let i = 0; i < this.menus.length; i++) {
		let menu = this.menus[i];
		info.push(menu.getForm());
	}

	return {
		name: this.name,
		level: this.level,
		articleId: this.article.id,
		personId: this.person.id,
		topicId: this.topic.id,
		sceneryId: this.scenery.id,
		type: this.type,
		url: this.url,
		location: this.location,
		menus: info
	}
}

TopicMenu.prototype.finish = function () {

	if (this.validate()) {
		this.errorMessage = null;
		this.editMode = false;
	}

}


TopicMenu.prototype.toggleEdit = function () {

	if (this.editMode) {
		this.finish();
	} else {
		this.editMode = true;
	}

}

//装填父节点信息。
TopicMenu.prototype.fillParentInfo = function (topic, parentMenu) {

	//把自己装好。
	this.parentTopic = topic;
	this.parent = parentMenu;

	//把儿子装填好。
	if (this.isParent()) {
		for (let i = 0; i < this.menus.length; i++) {
			let menu = this.menus[i];

			menu.fillParentInfo(topic, this);
		}

	}

}


TopicMenu.prototype.addField = function () {

	let topicMenu = new TopicMenu();
	topicMenu.editMode = true;
	topicMenu.level = this.level + 1;
	topicMenu.parentTopic = this.parentTopic;
	topicMenu.parent = this;
	this.menus.push(topicMenu);
}


//获取url的父路径 在编辑属性的页面中有用到。
TopicMenu.prototype.getUrlBase = function () {

	let str = "/";

	if (this.parentTopic) {
		str += this.parentTopic.location;
	} else {
		console.error(this);
	}

	if (this.level === 0) {
		return str + "/";
	} else if (this.level === 1) {
		return str + "/" + this.parent.location + "/";
	} else {
		console.error("We DO NOT support level > 1");
		return "ERROR";
	}
}

//获取url
TopicMenu.prototype.getUrl = function () {
	return this.getUrlBase() + this.location;
}


TopicMenu.prototype.click = function () {

	if (this.type === Type.ARTICLE || this.type === Type.PERSON || this.type === Type.SCENERY) {

		Vue.router.push(this.getUrl());
	} else if (this.type === Type.TOPIC) {


		if (this.topic.id === 1) {
			Vue.router.push("/");
		} else {
			Vue.router.push("/" + this.topic.location);
		}

	} else if (this.type === Type.URL) {
		window.open(this.url);
	} else if (this.type === Type.PARENT) {
		this.menus[0].click();
	}

}





// WEBPACK FOOTER //
// ./src/common/model/topic/TopicMenu.js